/**
 * Formats a date the way the workflow document writes affidavit and counter-statement dates:
 * "25th day of November 2025" (spec pg 96 / pg 125 / pg 137).
 *
 * Shared because three review windows need it — Prepare Counter, Evidence Affidavit and the User
 * Affidavit for Hearing — and it previously lived as a private function inside one view.
 */
export function formatOrdinalLongDate(d: Date): string {
  const day = d.getDate();
  const suffix =
    day % 100 >= 11 && day % 100 <= 13
      ? "th"
      : day % 10 === 1
        ? "st"
        : day % 10 === 2
          ? "nd"
          : day % 10 === 3
            ? "rd"
            : "th";
  const month = d.toLocaleDateString("en-GB", { month: "long" });
  return `${day}${suffix} day of ${month} ${d.getFullYear()}`;
}
